<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-question-circle" class="q-mb-sm" /> {{ $t(title_faq) }}
        </div>

        <filters
			class="filter-card"
			:options="getOptionsFilter"
			@requestFiltered="requestFiltered"
			@clearAndRequest="clearAndRequest"
		/>

        <q-table
            :data="faqs"
            :columns="columns"
            :pagination.sync="server_pagination"
            @request="request"
            :loading="loading"
            :filter="filter"
            row-key="name"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[5,10,50,100]"
            binary-state-sort
            >

            <template slot="top" slot-scope="props">
                <q-search v-model="filter" icon="fas fa-search" :placeholder="$t('search')" :debounce="500" />
                <div class="col" />
                <q-btn color="secondary" icon="fas fa-plus" :label="$t('new')" @click="$router.push({ name: 'admin_faq', params: { id: 0 } })" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    <div v-if="col.name == 'is_public' && show_public_faq">
                        {{ $t(col.label) }}
                    </div>
                    <div v-if="col.name != 'is_public'">
                        {{ $t(col.label) }}
                    </div>
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="id" :props="props">
                    {{ props.row.id }}
                </q-td>

                <q-td key="question" :props="props">
                    {{ props.row.question }}
                </q-td>

                <q-td key="faq_category" :props="props">
                    {{ getFaqCategory(props.row.faq_category) }}
                </q-td>

                <q-td key="status" :props="props" auto-width>
                    <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width">
                        {{ $t(getStatus(props.row.status)) }}
                    </q-chip>
                </q-td>

                <q-td key="is_public" :props="props" auto-width v-if="show_public_faq">
                    {{ props.row.is_public ? $t('yes') : $t('no') }}
                </q-td>

                <q-td key="actions" :props="props">
                    <q-btn flat round color="primary" icon="fas fa-pencil-alt" @click="$router.push({ name: 'admin_faq', params: { id: props.row.actions } })" >
                        <q-tooltip>
                            {{ $t('view_or_edit_tooltip')}}
                        </q-tooltip>
                    </q-btn>

                    <q-btn flat round color="negative" icon="far fa-trash-alt" @click="confirmRemove(props.row.actions)" >
                        <q-tooltip>
                            {{ $t('delete_tooltip')}}
                        </q-tooltip>
                    </q-btn>
                </q-td>
            </q-tr>
        </q-table>

        <q-dialog v-model="confirm_remove" @ok="removeItem">
            <span slot="title">{{ $t('remove_item') }}</span>

            <span slot="message">{{ $t('confirm_remove_item') }}</span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
                <q-btn color="negative" :label="$t('remove')" @click="removeItem()" />
            </template>
        </q-dialog>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
import { LocalStorage } from 'quasar'
import Filters from 'components/admin/faq/Filters.vue'

export default {
    i18nOptions: { namespaces: ['common', 'faq', 'admin'] },

    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            loading: false,
            faqs: [],
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'name',
                    sortable: true,
                },
                {
                    name: 'question',
                    required: true,
                    label: 'question',
                    align: 'left',
                    field: 'question',
                    sortable: true,
                },
                {
                    name: 'faq_category',
                    required: true,
                    label: 'faq_category',
                    align: 'left',
                    field: 'faq_category',
                    sortable: true,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: true,
                },
                {
                    name: 'is_public',
                    required: true,
                    label: 'is_public',
                    align: 'left',
                    field: 'is_public',
                    sortable: true,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'edit',
                    sortable: false,
                },
            ],
            filter: '',
            action_id: '',
            confirm_remove: false,
            filter_faq_categories: [],
            filter_is_public: null,
			filter_status: null,
        }
    },

    components: {
		filters: Filters,
	},

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
			faq_categories: 'registration_lists/faq_categories',
			clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
            show_public_faq: 'params/login_show_public_faq',
            num_rows: 'datatable/num_rows',
			faqs_filters: 'admin_filters/faqs_filters',
		}),

		title_faq(){
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_faq == '' ? 'faq' : obj.title_faq
				}
			}
		},

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getOptionsFilter() {
			return {
				faq_categories: this.faq_categories ? this.faq_categories : [],
				is_public: [
					{ value: true, label: this.$t('yes') },
					{ value: false, label: this.$t('no') },
				],
                statuses: [
					{ value: 1, label: this.$t('published') },
					{ value: 2, label: this.$t('unpublished') },
				],
			}
		},

		haveFilter() {
			for (const property in this.faqs_filters) {
                if (property === 'is_public' || property === 'status') {
                    if (this.faqs_filters[property] != null) return true
                } else {
                    if (this.faqs_filters[property].length > 0) return true
                }
			}
			return false
		},
    },

    methods: {
        request ({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter,
                "ordering": order_by,
                "is_public": this.filter_is_public,
                "faq_category__id__in": this.filter_faq_categories,
                "status": this.filter_status
            }

            this.savePagination()

            this.$axios.get('/admin_faq/faq_questions/?' + this.$qs.stringify(data , {
						arrayFormat: 'repeat',
					}), this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count
                this.faqs = []

                response.data.results.forEach(result => {
                    this.faqs.push({
                        id: result.id,
                        created_date: result.created_date,
                        faq_category: result.faq_category,
                        faq_question_answer: result.faq_question_answer,
                        question: result.question,
                        status: result.status,
                        is_public: result.is_public,
                        user: result.user,
                        actions: result.id
                    })
                })

                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        requestFiltered() {
			this.filter_faq_categories = this.faqs_filters.faq_categories
			this.filter_is_public = this.faqs_filters.is_public
			this.filter_status = this.faqs_filters.status

			this.request({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: this.num_rows,
					descending: false,
					sortBy: null,
				},
			})
		},

		clearAndRequest() {
			this.filter_faq_categories = []
			this.filter_is_public = undefined
			this.filter_status = undefined

			this.request({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: this.num_rows,
					descending: false,
					sortBy: null,
				},
			})
		},

        fetchLists() {
            this.$q.loading.show()

            this.$axios.get('/accounts/get_registration_lists/', this.getHeader)
            .then(response => {
                this.$store.dispatch('registration_lists/SET_LISTS', [response.data])
                this.$q.loading.hide()

                if (this.haveFilter) {
                    this.requestFiltered()
                } else {
                    this.request({
                        pagination: this.server_pagination,
                    })
                }
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        confirmRemove(id) {
            this.action_id = id
            this.confirm_remove = true
        },

        removeItem() {
            this.$q.loading.show()

            this.$axios.delete(`/admin_faq/faq_questions/${this.action_id}/`, this.getHeader)
            .then(response => {
                this.$q.loading.hide()

                if (this.haveFilter) {
                    this.requestFiltered()
                } else {
                    this.request({
                        pagination: this.server_pagination,
                    })
                }

                this.confirm_remove = false

                this.$q.notify({
                    message: this.$t('item_removed_success'),
                    type: 'positive',
                    icon: 'far fa-trash-alt'
                })
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        getFaqCategory(id) {
            let obj = this.faq_categories.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getStatus(status) {
            if (status == 1) return 'published'
            else if (status == 2) return 'unpublished'
            else if (status == 3) return 'deleted'
        },

        getIconStatus(status) {
            if (status == 1) return 'fas fa-check'
            else if (status == 2) return 'fas fa-ban'
            else if (status == 3) return 'fas fa-trash-alt'
        },

        getColorStatus(status) {
            if (status == 1) return 'positive'
            else if (status == 2) return 'warning'
            else if (status == 3) return 'negative'
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        }
    },

    created() {
        this.loadPagination()
        this.fetchLists()
    }
}
</script>

<style lang="stylus" scoped>

</style>
